package tables.category

import categoryModelToJsonString
import emotion.react.css
import kotlinx.browser.window
import models.CategoryModel
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.select
import react.useState
import token
import urlAddress
import web.cssom.*
import web.html.InputType
import web.http.Headers

external interface CreateCategoryProps : Props {
    var isOpen: Boolean
    var listCategoryModel: List<CategoryModel>
    var onClose: () -> Unit
    var onUpdate: () -> Unit
}

val CreateCategoryModal = FC<CreateCategoryProps> { props ->
    if (props.isOpen) {
        var categoryName by useState("")
        var status by useState("")
        var parent by useState("Главная")
        var iscategory by useState(false)
        var isactive by useState(false)

        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                p {
                    +"Наименование:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = categoryName
                    type = InputType.text
                    onChange = { event ->
                        categoryName = event.target.value
                    }
                }
                p {
                    +"Категория:"
                }
                div {
                    select {
                        value = parent
                        option {
                            +"Главная"
                        }
                        props.listCategoryModel.forEach {
                            option {
                                +it.name
                            }
                        }
                        onChange = {
                            parent = it.target.value
                        }
                    }
                }
                p {
                    +"Является категорией:"
                }
                div {
                    input {
                        type = InputType.checkbox
                        checked = iscategory
                        onChange = {
                            iscategory = it.target.checked
                        }
                    }
                }
                p {
                    +"Активная:"
                }
                div {
                    input {
                        type = InputType.checkbox
                        checked = isactive
                        onChange = {
                            isactive = it.target.checked
                        }
                    }
                }
                div {
                    css {
                        paddingTop = 20.px
                        display = Display.flex
                        justifyContent = JustifyContent.spaceAround
                    }
                    button {
                        +"Сохранить"
                        disabled = (categoryName.length < 3)
                        onClick = {
                            window.fetch(
                                urlAddress + "api/category", RequestInit(
                                    method = "POST",
                                    headers = Headers().apply {
                                        append("Authorization", "Bearer $token")
                                        append("Content-Type", "application/json")
                                    },
                                    body = categoryModelToJsonString(CategoryModel(0, categoryName, parent, iscategory, isactive))
                                )
                            )
                                .then { response ->
                                    if (response.ok) {
                                        props.onClose()
                                        props.onUpdate()
                                    } else {
                                        status = "Ошибка"
                                    }
                                }
                        }
                    }
                    button {
                        +"Отмена"
                        onClick = {
                            props.onClose()
                        }
                    }
                }
                p {
                    +status
                }
            }
        }
    }
}

